import { render, staticRenderFns } from "./repayment_add.vue?vue&type=template&id=51f521f5&scoped=true&"
import script from "./repayment_add.vue?vue&type=script&lang=js&"
export * from "./repayment_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f521f5",
  null
  
)

export default component.exports